import { Injectable } from '@angular/core';
import { ITableConfig } from 'codex-lib';
import {
  IDataTableBodyRow,
  IDataTableHeader,
} from '../Interface/envelope-data-table.interface';

@Injectable({
  providedIn: 'root',
})
export class EnvelopeDataTableService {
  buildHeader(headers: Array<IDataTableHeader>): Array<IDataTableHeader> {
    return headers || [];
  }

  buildBody(body: Array<IDataTableBodyRow>): Array<IDataTableBodyRow> {
    return body || [];
  }

  refreshDataTableOptions(
    headers: Array<IDataTableHeader>,
    body: Array<IDataTableBodyRow>,
    options: Partial<ITableConfig> = {}
  ): ITableConfig {
    return {
      isSelectable: false,
      isTableHover: true,
      tableOrderable: false,
      isTableBox: true,
      tableResponsiveness: {
        smallBreakpoint: true,
        mediumBreakpoint: headers.filter(h => h.show).length > 3,
        largeBreakpoint: false,
        extraLargeBreakpoint: false
      },
      header: this.buildHeader(headers),
      body: this.buildBody(body),
      ...options,
    } as ITableConfig;
  }
}
